import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Aux, TextInput } from '../../../Components';
import threeD from './images/3d.png';
import classic from './images/classic.png';
import graphing from './images/graphing.png';
import geometry from './images/geometry.png';
import classes from './roomOpts.css';

const ggbOpts = [
  { img: classic, name: 'Classic', appName: 'classic' },
  { img: threeD, name: '3D', appName: '3d' },
  { img: graphing, name: 'Graphing', appName: 'graphing' },
  { img: geometry, name: 'Geometry', appName: 'geometry' },
];
class RoomOpts extends Component {
  render() {
    const {
      roomType,
      appName,
      setGgbApp,
      setGgbFile,
      tab,
      desmosLink,
      setDesmosLink,
      setDesmosCalcLink,
    } = this.props;
    if (roomType === 'geogebra') {
      return (
        <div className={classes.RoomOpts}>
          <p>Sélectionnez une application GeoGebra</p>
          <div className={classes.Container}>
            {ggbOpts.map((opt) => (
              <div
                key={opt.appName}
                className={classes.Opt}
                onClick={() => {
                  setGgbApp(opt.appName);
                }}
                onKeyPress={() => {
                  setGgbApp(opt.appName);
                }}
                tabIndex="-1"
                role="button"
                data-testid={opt.appName}
              >
                <div
                  className={
                    appName === opt.appName ? classes.Selected : classes.GgbIcon
                  }
                >
                  <img src={opt.img} alt={opt.name} />
                </div>
                <h3 className={classes.OptText}>{opt.name}</h3>
              </div>
            ))}
          </div>
          <p>ou télécharger un fichier GeoGebra</p>
          <div>
            <div className={classes.Geogebra}>
              <input
                type="file"
                id="file"
                multiple
                name="ggbFile"
                accept=".ggb"
                onChange={setGgbFile}
              />
            </div>
          </div>
          {!tab ? (
            <p>("facultatif, cliquez sur suivant si vous souhaitez ignorer cette étape")</p>
            ) : null}
        </div>
      );
    }
    if (roomType === 'desmosActivity') {
      return (
        <Aux>
          <TextInput
            light
            name="desmosInput"
            label="CONFIGURATION DE L'ACTIVITÉ DESMOS"
            change={setDesmosLink}
            width="100%"
          />
          <p>Code d'activité Desmos:</p>
          <div className={classes.Code}>{desmosLink}</div>
          <br />
          <p>
            Collez dans une URL de partage de générateur d'activité ou un code de hachage à partir de
            teacher.desmos
          </p>
          <br />
          <p>
            Les activités Desmos sont en pré-Alpha, veuillez vous attendre et signaler les problèmes.
            Seules les activités en anglais sont prises en charge pour le moment.
          </p>
        </Aux>
      );
    }
    if (roomType === 'pyret') {
      return (
        <Aux>
          <p>Pyret Activity Configuration:</p>
          <p>Ne rien faire du tout pour l'instant</p>
        </Aux>
      );
    }
    return (
      <Aux>
        <TextInput
          light
          name="desmosInput"
          label="COLLER UN CODE OU UN LIEN D'ESPACE DE TRAVAIL GRAPHIQUE DESMOS (FACULTATIF)"
          change={setDesmosCalcLink}
          width="100%"
        />
        <p>Desmos Graph URL:</p>
        <a
          className={classes.Code}
          target="_blank"
          rel="noopener noreferrer"
          href={desmosLink}
        >
          {desmosLink}
        </a>
      </Aux>
    );
  }
}

RoomOpts.propTypes = {
  roomType: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  setGgbApp: PropTypes.func.isRequired,
  setGgbFile: PropTypes.func.isRequired,
  tab: PropTypes.bool,
  desmosLink: PropTypes.string.isRequired,
  setDesmosLink: PropTypes.func.isRequired,
  setDesmosCalcLink: PropTypes.func.isRequired,
};

RoomOpts.defaultProps = {
  tab: false,
};

export default RoomOpts;


// WEBPACK FOOTER //
// ./src/Containers/Create/NewResource/RoomOpts.js